import { Substitutions } from 'widgets';
import { Substitutions as SubstitutionsFeatures } from 'features';
import { useTitle } from '../helpers';

/**
 * @page Substitutions page
 */
const SubstitutionsPage = () => {
  useTitle('Замещения');

  return (
    <div>
      <h3>Замещения</h3>
      <Substitutions />
      <SubstitutionsFeatures.СontrolDrawer />
    </div>
  );
};

export default SubstitutionsPage;
